export type InquiryType = '' | 'partnership' | 'demo' | 'research' | 'government' | 'media' | 'general'

export const inquiryReasons: { value: Exclude<InquiryType, ''>; title: string; option: string; description: string }[] = [
  {
    value: 'partnership',
    title: 'Partnership Inquiries',
    option: 'Partnership Inquiry',
    description: 'Explore collaboration opportunities with educational institutions, employers, governments, or research organizations.',
  },
  {
    value: 'demo',
    title: 'Demos & Pilot Discussions',
    option: 'Demo or Pilot Discussion',
    description: 'Request a Semantic Knowledge Platform demonstration, discuss Human Capability research with CJI and NCJI, or explore a planned Noetivra pilot.',
  },
  {
    value: 'research',
    title: 'Research Collaboration',
    option: 'Research Collaboration',
    description: 'Discuss joint research initiatives, pilot programs, or academic partnerships.',
  },
  {
    value: 'government',
    title: 'Government & Public Sector',
    option: 'Government & Public Sector',
    description: 'Inquire about civic resilience planning, civil service modernization, or leadership qualification frameworks.',
  },
  {
    value: 'media',
    title: 'Media & Press',
    option: 'Media & Press',
    description: 'Media inquiries, interview requests, or information about SyNeural’s mission, systems, and frameworks.',
  },
  {
    value: 'general',
    title: 'General Inquiries',
    option: 'General Inquiry',
    description: 'Any other questions about SyNeural, our work, or how we might be able to help.',
  },
]

export const directContacts = [
  { label: 'General inquiries', email: 'contact@syneural.com' },
  { label: 'Institutional partnerships', email: 'partnerships@syneural.com' },
]
